import { pickLocalized, useLanguage } from '@/features/i18n';

type RouteLoadingShellElement = 'div' | 'main';

interface RouteLoadingShellProps {
  route: string;
  title?: string;
  description?: string;
  element?: RouteLoadingShellElement;
  className?: string;
}

export default function RouteLoadingShell({
  route,
  title,
  description,
  element = 'main',
  className = '',
}: RouteLoadingShellProps) {
  const { language } = useLanguage();
  const resolvedTitle = title ?? pickLocalized(language, {
    ko: '페이지 준비 중…',
    en: 'Preparing the page…',
    ja: 'ページを準備しています…',
  });
  const resolvedDescription = description ?? pickLocalized(language, {
    ko: '필요한 화면 자산을 불러오고 있습니다.',
    en: 'Loading the required page assets.',
    ja: '必要な画面アセットを読み込んでいます。',
  });
  const kicker = pickLocalized(language, {
    ko: '잠시만 기다려주세요',
    en: 'Please wait a moment',
    ja: 'しばらくお待ちください',
  });
  const Element = element;
  const classes = ['route-shell', 'route-loading-shell', className].filter(Boolean).join(' ');

  return (
    <Element className={classes} data-route={route} aria-busy="true">
      <div className="route-loading-card" data-testid="route-loading-shell">
        <span className="route-loading-kicker">{kicker}</span>
        <h1>{resolvedTitle}</h1>
        <p>{resolvedDescription}</p>
      </div>
    </Element>
  );
}
